export class ActivityModalService {
  static $inject = ['$modal'];

  constructor(private $modal) { }

  add(organizations, member) {
    const modalInstance = this.$modal.open({
      animation: true,
      template:
        '<new-activity-modal modal-instance="modalInstance" member="member" organizations="organizations"></new-activity-modal>',
      windowClass: 'new-activity-modal',
      controller: [
        '$scope',
        '$modalInstance',
        'member',
        'organizations',
        function ($scope, $modalInstance, member, organizations) {
          $scope.modalInstance = $modalInstance;
          $scope.member = member;
          $scope.organizations = organizations;
        },
      ],
      resolve: {
        member: () => member,
        organizations: () => organizations,
      },
    });

    return modalInstance.result;
  }

  edit(organizations, activity) {
    const modalInstance = this.$modal.open({
      animation: true,
      template:
        '<update-activity-modal modal-instance="modalInstance" activity="activity" organizations="organizations"></update-activity-modal>',
      controller: [
        '$scope',
        '$modalInstance',
        'activity',
        'organizations',
        function ($scope, $modalInstance, activity, organizations) {
          $scope.modalInstance = $modalInstance;
          $scope.activity = activity;
          $scope.organizations = organizations;
        },
      ],
      windowClass: 'update-activity-modal',
      resolve: {
        activity: () => activity,
        organizations: () => organizations,
      },
    });

    return modalInstance.result;
  }
}
